import { useEffect, useRef } from "react";
import * as XLSX from "xlsx";

export default function ExcelPreview({ fileUrl }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!fileUrl || !containerRef.current) return;

    fetch(fileUrl)
      .then((res) => res.arrayBuffer())
      .then((ab) => {
        const wb = XLSX.read(ab, { type: "array" });

        const luckysheetData = wb.SheetNames.map((name) => {
          const ws = wb.Sheets[name];
          const json = XLSX.utils.sheet_to_json(ws, { header: 1 });
          return {
            name,
            data: json.map((row) => row.map((cell) => ({ v: cell }))),
          };
        });

        // 기존 Luckysheet 제거 후 새로 생성
        document.getElementById("excel-container").innerHTML = "";

        window.luckysheet.create({
          container: "excel-container",
          data: luckysheetData,
          lang: "en",
          showtoolbar: false,
          showinfobar: false,
          allowEdit: true, // ✅ 편집 허용해두고
          config: {
            readOnly: true, // ✅ 읽기 전용 모드 (수정 불가, 스크롤/클릭은 가능)
          },
          containerWidth: "100%",
          containerHeight: "100%",
        });

        // 초기화 후 리프레시 (이벤트/스크롤 fix)
        setTimeout(() => {
          window.luckysheet.refresh();
        }, 200);
      });
  }, [fileUrl]);

  return (
    <div
      style={{
        width: "100%",
        height: "600px",
        position: "relative",
        border: "1px solid #ddd",
        borderRadius: "0.5rem",
        background: "#fff",
        overflow: "hidden",
      }}
    >
      <div
        id="excel-container"
        ref={containerRef}
        style={{
          width: "100%",
          height: "100%",
          overflow: "auto",      // ✅ 스크롤 허용
          pointerEvents: "auto", // ✅ 클릭 허용
        }}
      />
    </div>
  );
}
